<template>
  <v-card>
    <v-data-table :headers="headers" :items="categorie">
      <template v-slot:top>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Categorie Movimenti
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="nuova_categoria_dialog = true"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Crea Categoria</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
      </template>
    </v-data-table>

    <v-dialog v-model="nuova_categoria_dialog">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Nuova Categoria</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="creaCategoria" small v-bind="attrs" v-on="on"
                ><v-icon color="success">mdi-floppy</v-icon></v-btn
              >
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiDialog" small v-bind="attrs" v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="temp.categoria"
                  label="Nome nuova categoria movimento"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: {
    SnackbarQV,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      nuova_categoria_dialog: false,
      // Modal
      // Array
      temp: { categoria: "" },
      categorie: [{ categoria: "test01" }, { categoria: "test02" }],
      headers: [
        {
          text: "Categoria Movimento",
          value: "categoria",
        },
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi");
    },

    chiudiDialog() {
      this.nuova_categoria_dialog = false;
    },

    creaCategoria() {
      this.$set(
        this.categorie,
        this.categorie.length,
        Object.assign({}, this.temp)
      );
      this.nuova_categoria_dialog = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Nuova categoria di movimento creata"
      );
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>